import { useState } from 'react';
import { Column, Row } from '../../components/Grid/Grid';
import StoreLogo from '../Store/StoreLogo';
import StoreName from '../Store/StoreName';
import ProductsCount from './ProductsCount';
import useStyles from './styles';
import { Spaced, RightSpaced } from '../../components/Spaced/Spaced';
import Icon from '../../components/Icon/Icon';
import Button from '../../components/Button/Button';
import ProductList from './ProductList';
import AppLoading from '../App/AppLoading';
import ProductPanelLoading from './ProductPanelLoading';
import Currency from '../../components/Currency/Currency';
import useCart from '../Cart/useCart';

function ProductPanel() {
  const classes = useStyles();
  const [showList, setShowList] = useState(false);
  const { total } = useCart();

  return (
    <div className={classes.container}>
      <Button type="panel" onClick={() => setShowList(true)} data-testid="productPanel">
        <Spaced>
          <AppLoading loadingComponent={<ProductPanelLoading />}>
            <Row justifyContent="space-between">
              <Row>
                <RightSpaced>
                  <StoreLogo />
                </RightSpaced>
                <Column>
                  <StoreName />
                  <ProductsCount />
                </Column>
              </Row>
              <Row>
                <Currency value={total} />
                <Icon name="angleRight" className={classes.angleRightIcon} />
              </Row>
            </Row>
          </AppLoading>
        </Spaced>
      </Button>
      <ProductList show={showList} onClose={() => setShowList(false)} />
    </div>
  );
}

export default ProductPanel;
